import React from 'react';
import { Label } from '@/components/ui/label';
import IconInput from './IconInput';

/**
 * Labeled input row for the auth forms (SignIn / NewPassword / RecoverPassword).
 * Owns the label/input/error layout so the three forms stay in sync.
 *
 * Accessibility: when `error` is set the input gets aria-invalid + a red border,
 * and aria-describedby points at the error <p> so screen readers announce the
 * message, not just "invalid".
 */
const Field = ({ id, label, error, ...props }) => {
  const errorId = `${id}-error`;
  return (
    <div>
      <Label htmlFor={id} className="mb-2 block text-slate-700">
        {label}
      </Label>
      <IconInput
        id={id}
        {...props}
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        className={error ? 'border-red-500 focus-visible:ring-red-500' : undefined}
      />
      {error ? (
        <p id={errorId} className="mt-1 text-[13px] text-red-500">
          {error}
        </p>
      ) : null}
    </div>
  );
};

export default Field;
